import { useState, useEffect } from 'react';
import { jwtDecode } from 'jwt-decode'; // Импортируем нашу библиотеку
import { useNavigate } from 'react-router-dom';

export const useAuth = () => {
  const [user, setUser] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    // При загрузке компонента пытаемся найти токен
    const token = localStorage.getItem('hatchup_token');
    if (token) {
      try {
        // Если токен есть, декодируем его и сохраняем данные пользователя
        const decodedUser = jwtDecode(token);
        setUser(decodedUser);
      } catch (error) {
        // Если токен "битый", удаляем его
        localStorage.removeItem('hatchup_token');
      }
    }
  }, []); // Пустой массив зависимостей означает, что эффект выполнится один раз

  // Функция выхода из системы
  const logout = () => {
    localStorage.removeItem('hatchup_token'); // Удаляем токен
    setUser(null); // Очищаем данные пользователя
    navigate('/login'); // Перенаправляем на страницу входа
  };

  return { user, logout };
};